/**
 * @author sgdh
 * 模块说明：采购中心
 */

// 采购中心-采购需求
import { procureRequireService } from './require'

import { procureOrderService } from './order'

import { ProcureSupplierInvoice } from './supplier'

import { requireExternalBizWarehouseService } from './bizWarehouse'

import { FixedPriceService } from './fixedPrice'

// 采购策略-供应商寻源配置
import { RequireConfigSourceService } from './requireConfigSource'

// 采购策略-供应商寻源规则配置
import { requireConfigSourceItemService } from './requireConfigSourceItem'

export const require = new procureRequireService('/api/procure/require')

export const order = new procureOrderService('/api/procure/order')

export const supplier = new ProcureSupplierInvoice('/api/procure/supplier/invoice')

export const bizWarehouse = new requireExternalBizWarehouseService('/api/procure/require/external/bizWarehouse')

export const fixedPrice = new FixedPriceService('/api/procure/fixedPrice')

export const requireConfigSource = new RequireConfigSourceService('/api/procure/require/config/source')

export const requireConfigSourceItem = new requireConfigSourceItemService('/api/procure/require/config/source/item')

// 新品添加前数据校验
import { RequireExternalService } from './requireExternal'
export const requireExternal = new RequireExternalService('/api/procure/require/external/')

// 采购分仓
import { WarehouseConfigService } from './warehouseConfig'
// 版别关联供应商
import { EditionConfigService } from './editionConfig'
// 定向采购
import { OrientConfigService } from './orientConfig'
// 退货申请单管理
import { ReturnApplyService } from './returnApply'
// 回告异常
import { ReturnService } from './return'
// 采购单管理
// import { purchaseOrderListService } from './purchaseOrderList'
// 采购调整单管理
import { AdjustService } from './adjust'
// 采购需求管理-中心内接口调用
import { RequireInternalService } from './requireInternal'
// 采购单详情管理
import { OrderDetailService } from './orderDetail'
// 进退单
import { ReturnOrderService } from './returnOrder'
// 供应商发货清单异常处理
import { ProcureSupplierAbnormal } from './abnormal'
// 可退查询
import { ProcureReturnableQueryServer } from './returnableQuery'
// 收货通知单列表
import { noticeService } from './notice'
// 品种转移
import { VarietyTransfe } from './variety'
// 品种替换管理

import { replacementService } from './replacement'

// 优先级配置
import { fixedPriceConfigService } from './fixedPriceConfig'

// 供货清单导入列表
import { supplyService } from './supply'

// 采购需求管理-外部接口
import { externalService } from './external'

// 新品发布
import { SupplierCommodityService } from './supplierCommodity'

//调剂单
import { makeUpAPrescriptionService } from './makeUpAPrescription'

export const supplierCommodity = new SupplierCommodityService('/api/procure/supplier/commodity')

export const external = new externalService('/api/procure/require/external')
export const supply = new supplyService('/api/procure/supply')
export const fixedPriceConfig = new fixedPriceConfigService('/api/procure/fixedPriceConfig')
export const Notice = new noticeService('/api/procure/supplier/receipt/notice')
export const returnableQuery = new ProcureReturnableQueryServer('/api/procure/allow/return/commodity')

export const warehouseConfig = new WarehouseConfigService('/api/procure/warehouseConfig')

export const editionConfig = new EditionConfigService('/api/procure/editionConfig')

export const orientConfig = new OrientConfigService('/api/procure/orientConfig')

export const returnApply = new ReturnApplyService('/api/procure/return/apply')

export const AReturn = new ReturnService('/api/procure/return')

export const abnormal = new ProcureSupplierAbnormal('/api/procure/supplier/abnormal')
// export const purchaseOrderList = new purchaseOrderListService('/api/procure/order')

export const adjust = new AdjustService('/api/procure/adjust')

export const requireInternal = new RequireInternalService('/api/procure/require/internal')

export const orderDetail = new OrderDetailService('/api/procure/order/detail')

export const returnOrder = new ReturnOrderService('/api/procure/return/order')

export const Variety = new VarietyTransfe('/api/procure/variety/transfer/task')

export const replacement = new replacementService('/api/procure/variety/replacement/task')

export const makeUpAPrescription = new makeUpAPrescriptionService('/api/procure/adjustment')
